import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'email-supplier',
  templateUrl: 'email-supplier.component.html',
  styleUrls: ['email-supplier.component.scss']
})

export class EmailSupplierComponent {
  @Input() showEmailContent: any;
  @Input() latestSentEmailSupplierInfo: any;

  @Output() onEmailSupplier: EventEmitter<any> = new EventEmitter();

  emailSupplier() {
    this.onEmailSupplier.emit();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/email-supplier/email-supplier.component.ts